import React, { ChangeEvent, FocusEvent, FormEvent, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import WelcomeImage from '../../Components/ImagesWithElements/WelcomeImage';
import styled from "styled-components";
import usePortalService from '../../services/PortalService';
import { ResetPasswordEmailSended } from '../../Components/Modals/ResetPasswordEmailSended';
import { type } from 'os';
 
const Styles = styled.div`
div {
    color: var(--grey-grey-8, #717171);
    font-family: Open Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
}
`

type ForgotPasswordProps = {
    setRegister?: (value: boolean) => void;
    setToken?: (token: string) => void;
}

export default function ForgotPassword({ setRegister, setToken }: ForgotPasswordProps) {
    const {createResetPasswordLinks} = usePortalService();
    const navigate = useNavigate();

    const regEmail = /[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+/;
    const [email, setEmail] = useState('');
    const [emailDirty, setEmailDirty] = useState(false);
    const [emailError, setEmailError] = useState('Некорректный email');
    const [isSended, setIsSended] = useState(false);
    const [resetPasswordError, setResetPasswordError] = useState('');

    const blurHandler = (e: FocusEvent<HTMLInputElement>) => {
        if (e.target.name === 'email') {
            setEmailDirty(true);
        }
    };

    const emailHandler = (e: ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
        if (!regEmail.test(String(e.target.value).toLowerCase())) {
            setEmailError('Некорректный email')
        } else {
            setEmailError('')
        }
    }

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        if (emailError) {
            setEmailDirty(true)
        } else {
            const result = await createResetPasswordLinks({
                login: email
            });
            if (result.success) {
                setIsSended(true);
                setResetPasswordError('');
            }
            else {
                setResetPasswordError(result.errors);
            }
        }
    }

    return (
        <Styles>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <WelcomeImage/>
                </section>
                <div className="content" >
                    {/* <div class="auth-nav">
                        <p class="auth-link"> Еще нет аккаунта?&nbsp; </p>
                        <Link to="/registration"> Регистрация </Link>
                    </div> */}
                    <div className="auth-content">
                        <h1 style={{ marginBottom: '8px' }}> Забыли пароль? </h1>
                        <div> Введите email, который использовали при входе в систему, и мы отправим Вам инструкцию по сбросу пароля.</div>
                        <div style={{marginBottom: '32px'}}> Или воспользуйтесь <Link to="/simpleLogin"> одноразовым кодом для входа </Link></div>
                        <Form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <Form.Label> Email </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='email' 
                                    id="email"
                                    value={email} 
                                    onBlur={blurHandler} 
                                    onChange={emailHandler} 
                                    isInvalid={emailDirty && !!emailError}
                                />
                                {(emailDirty && emailError) && <p className="error-alert">{emailError}</p>}
                            </div>
                            <br />
                            <Button variant="primary" type="submit" style={{width: '173px', height: '40px'}}> Отправить </Button>
                            <p className="error-alert">{resetPasswordError}</p>
                        </Form>
                    </div>
                </div>
                <ResetPasswordEmailSended isOpen={isSended} close={() => setIsSended(false)} />
            </div>
        </Styles>
    );
};